// ─── Unicode Fractions ─────────────────────────────────────────────────────────
const FRACTIONS = [
  [1/8, '⅛'], [1/4, '¼'], [3/8, '⅜'], [1/2, '½'],
  [5/8, '⅝'], [3/4, '¾'], [7/8, '⅞'],
]

export function formatAmount(amount) {
  if (amount === null || amount === undefined) return ''
  const num = Number(amount)
  if (isNaN(num)) return String(amount)
  const whole = Math.floor(num)
  const frac = num - whole
  if (frac < 0.01) return String(whole)
  for (const [val, sym] of FRACTIONS) {
    if (Math.abs(frac - val) < 0.03) {
      return whole > 0 ? `${whole}${sym}` : sym
    }
  }
  return num % 1 === 0 ? String(num) : num.toFixed(2).replace(/\.?0+$/, '')
}

// ─── Conversion Tables ─────────────────────────────────────────────────────────
// Each entry: [fromUnit, toUnit, factor]
const CONV = {
  flour: [
    { label: 'Grams (g)', key: 'g', toG: 1 },
    { label: 'Cup',       key: 'cup', toG: 128 },
    { label: 'Ounce (oz)',key: 'oz', toG: 28.35 },
    { label: 'Tablespoon',key: 'tbsp', toG: 8 },
    { label: 'Teaspoon', key: 'tsp', toG: 2.67 },
  ],
  sugar: [
    { label: 'Grams (g)', key: 'g', toG: 1 },
    { label: 'Cup',       key: 'cup', toG: 200 },
    { label: 'Ounce (oz)',key: 'oz', toG: 28.35 },
    { label: 'Tablespoon',key: 'tbsp', toG: 12.5 },
    { label: 'Teaspoon', key: 'tsp', toG: 4.17 },
  ],
  liquid: [
    { label: 'Milliliter', key: 'ml', toG: 1 },
    { label: 'Liter',      key: 'l',  toG: 1000 },
    { label: 'Cup',        key: 'cup', toG: 240 },
    { label: 'Fl Oz',      key: 'fl oz', toG: 29.57 },
    { label: 'Tablespoon', key: 'tbsp', toG: 14.79 },
    { label: 'Teaspoon',   key: 'tsp', toG: 4.93 },
  ],
  fat: [
    { label: 'Grams (g)', key: 'g', toG: 1 },
    { label: 'Cup',       key: 'cup', toG: 227 },
    { label: 'Ounce (oz)',key: 'oz', toG: 28.35 },
    { label: 'Tablespoon',key: 'tbsp', toG: 14.2 },
    { label: 'Teaspoon', key: 'tsp', toG: 4.73 },
  ],
  other: [
    { label: 'Grams (g)', key: 'g', toG: 1 },
    { label: 'Ounce (oz)',key: 'oz', toG: 28.35 },
    { label: 'Kilogram',  key: 'kg', toG: 1000 },
    { label: 'Pound',     key: 'lb', toG: 453.59 },
  ],
}

function getTable(type) {
  if (!type) return CONV.other
  const t = type.toLowerCase()
  if (t.includes('flour') || t.includes('powder')) return CONV.flour
  if (t.includes('sugar') || t.includes('salt')) return CONV.sugar
  if (t.includes('liquid') || t.includes('water') || t.includes('milk') || t.includes('broth') || t.includes('oil')) return CONV.liquid
  if (t.includes('butter') || t.includes('fat') || t.includes('lard')) return CONV.fat
  return CONV.other
}

export function getConversions(amount, unit, type) {
  const table = getTable(type)
  const fromRow = table.find(r => r.key === (unit || '').toLowerCase())
  if (!fromRow || !amount) return []
  const grams = Number(amount) * fromRow.toG
  return table
    .filter(r => r.key !== fromRow.key)
    .map(r => ({
      label: r.label,
      value: formatAmount(Math.round((grams / r.toG) * 100) / 100),
      unit: r.key,
    }))
}

// Parse "12 min" → 720 seconds, "1 hr 30 min" → 5400, etc.
export function parseDuration(text) {
  if (!text) return null
  const lower = text.toLowerCase()
  let total = 0
  const hr = lower.match(/(\d+)\s*(h|hr|hour)/);  if (hr)  total += parseInt(hr[1]) * 3600
  const mn = lower.match(/(\d+)\s*(m|min|minute)/); if (mn) total += parseInt(mn[1]) * 60
  const sc = lower.match(/(\d+)\s*(s|sec|second)/); if (sc) total += parseInt(sc[1])
  return total > 0 ? total : null
}
